export var SocialMediaDisplayAreaEnum;
(function (SocialMediaDisplayAreaEnum) {
    SocialMediaDisplayAreaEnum["FOOTER"] = "FOOTER";
    SocialMediaDisplayAreaEnum["SIDEBAR"] = "SIDEBAR";
})(SocialMediaDisplayAreaEnum || (SocialMediaDisplayAreaEnum = {}));
//# sourceMappingURL=social-media-display-area.enum.js.map